import { InputAutocomplete } from '@innovyze/stylovyze';
import { getValue, schedulesSelector } from '@Selectors';
import { useFormikContext } from 'formik';
import React, { ChangeEvent, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CustomInfoCard } from './GeneralSettingsFields.styles';
import { CompanySettingsFull } from '../utils/GeneralSettingsUtils';
import useSetGeneralSettingsFields from '../utils/useSetGeneralSettingsFields';
import { Option } from '../GeneralSettings';
import { useGlobalization } from '@Translations';

export default function DefaultScenario() {
	const { t } = useGlobalization();

	const { schedules, initialized } = useSelector(schedulesSelector);

	const availableSchedulesOptions = useMemo(() => {
		return schedules
			.filter(schedule => schedule.visible)
			.map(schedule => ({
				key: schedule.id_,
				value: schedule.display_name,
			}));
	}, [schedules]);

	const { setValues, values } = useFormikContext<CompanySettingsFull>();
	const setGeneralSettingsFields = useSetGeneralSettingsFields();
	const companySettingsErrors =
		useSelector(getValue).companySettings.companySettingsErrors || {};

	useEffect(() => {
		if (initialized) {
			const scenario = values.defaultScenario;
			const availableScenario = availableSchedulesOptions.find(
				option => option.key === scenario,
			);
			/**
			 * clear the input to avoid displaying UUID in the list as the list is dynamic not constant
			 */
			if (!availableScenario) {
				setValues(vals => ({
					...vals,
					defaultScenario: '',
				}));
			}
		}
	}, [initialized]);

	const setCurrentScenario = (
		e: ChangeEvent<HTMLInputElement>,
		option?: Option,
	) => {
		if (option) {
			const defaultScenario = option.key;
			setGeneralSettingsFields({
				defaultScenario,
			});
		}
	};

	return (
		<CustomInfoCard fullHeight title={t('Default tenant scenario')}>
			<InputAutocomplete
				options={availableSchedulesOptions}
				fieldAttrs={{ name: 'defaultScenario' }}
				label={t('Scenario')}
				dataCy="tenantScenario"
				onChange={setCurrentScenario}
				networkError={companySettingsErrors.defaultScenario}
				autocompleteProps={{
					disableClearable: true,
				}}
			/>
		</CustomInfoCard>
	);
}
